import { StrategyTempleteSkeleton } from "components/skeleton/strategy";
import StrategyHeader from "components/templates/common/Strategy/Header";
import StrategyTemplete from "components/templates/common/Strategy/Index";
import useStrategyData, { useStrategyAssets } from "utils/clientAPIs/stragey";

function StrategyKM3_US() {
  const code = "km3_us";
  const [data, isLoading] = useStrategyData(code);
  const [assets, isValid] = useStrategyAssets(
    code,
    data?.strategyLogReturns?.[data?.strategyLogReturns?.length - 1]?.BASE_DT,
    data?.totalBaseDT?.[data?.totalBaseDT?.length - 1],
    undefined
  );

  const realtimeData =
    assets?.list?.length &&
    assets?.realTimekospi &&
    assets?.list?.[0]?.PRICE_CHG_LOG
      ? {
          assets: assets?.list?.map((asset: any) => {
            return {
              ITEM_CD_DL: asset?.ITEM_CD_DL,
              PRICE_CHG_LOG: asset?.PRICE_CHG_LOG || 0,
            };
          }),
          kospi: assets?.realTimekospi,
        }
      : null;

  return (
    <main className="min-w-[360px] max-w-[800px] w-screen bg-white">
      <StrategyHeader sCode={code} />
      {!isLoading && !isValid ? (
        <>
          <StrategyTemplete
            sCode={code}
            data={data}
            assets={assets}
            realtimeData={realtimeData}
          />
        </>
      ) : (
        <StrategyTempleteSkeleton />
      )}
    </main>
  );
}

export default StrategyKM3_US;
